import React from 'react';
import { NextPage } from 'next';
import Head from 'next/head';
import { useIntl } from 'react-intl';
import { PlaylistsSharingPremiumPricing } from './playlistsSharing/premium/PlaylistsSharingPremiumPricing';
import { MainNavbar } from '../../layouts/MainNavbar';
import { Footer } from '../../layouts/Footer';

export const PricingPage: NextPage = React.memo(() => {
  const intl = useIntl();
  const title = intl.formatMessage({
    id: 'sml.web.playlists-sharing.title',
    defaultMessage: 'Smart music sharing for DJs, influencers, and music curators'
  });
  const description = intl.formatMessage({
    id: 'sml.web.playlists-sharing.description-shorter',
    defaultMessage:
      'Promote your playlists, albums, and favorites. Reach music fans across all major streaming services and attract a new audience.'
  });
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="twitter:title" content={title} key="twitter-title" />
        <meta property="og:title" content={title} key="fb-title" />
        <meta itemProp="description" content={description} key="itemProp-description" />
        <meta name="description" content={description} key="description" />
        <meta property="og:description" content={description} key="fb-description" />
        <meta property="twitter:description" content={description} key="twitter-description" />
        <meta property="twitter:image:width" content="1200" key="twitter-image-width" />
        <meta property="twitter:image:height" content="600" key="twitter-image-height" />
      </Head>
      <MainNavbar />
      <PlaylistsSharingPremiumPricing />
      <Footer />
    </>
  );
});
